/**
 * This file is created manually
 * You can change the content
 *
 */

import H4 from './typography/H4'
export * from './typography/H4'
export default H4
